import React, { Component } from "react";
import { Alert, Button, Table, Spinner } from "react-bootstrap";

class HaproxyDescription extends Component {
    constructor() {
        super();

    }

    render() {
        return (
            <Alert style={{ width: '100%', cursor: 'pointer', }} >
                <div onClick={this.props.blockHaproxyDescriptionIsOpen ? this.props.closeBlockHaproxyDescription : this.props.openBlockHaproxyDescription}
                    style={{ display: "flex", borderBottom: this.props.blockHaproxyDescriptionIsOpen ? "1px solid #e3e3e3" : null, height: this.props.blockHaproxyDescriptionIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                    <div style={{ width: "55%" }}>
                        <div style={{ color: "black" }}>&bull; Haproxy </div>

                    </div>
                    <div style={{ width: "45%" }}>
                        <b style={{ color: "black", float: "right" }}>
                            {this.props.blockHaproxyDescriptionIsOpen ?
                                <div >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                </div> :
                                <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                            }
                        </b>
                    </div>

                </div>
                {
                    this.props.blockHaproxyDescriptionIsOpen ? <div style={{ color: "black" }}>
                        <p>
                            Cерверное программное обеспечение для обеспечения высокой доступности и балансировки нагрузки для TCP и HTTP-приложений,
                            посредством распределения входящих запросов на несколько обслуживающих серверов.
                        </p>
                        <p>
                            Пользователи сможет получить доступ к сайту, подключаясь к серверу HAProxy по HTTPS, который будет расшифровывать SSL-сессию и пересылать незашифрованные запросы на веб-серверы через их интерфейсы частной сети на порт 80.
                            Затем веб-серверы отправят ответы на сервер HAProxy, который зашифрует и отправит их обратно пользователю, который сделал запрос.
                            Все криптографические операции будут выполняться с помощью библиотеки LWOCrypt.
                        </p>
                    </div> : null
                }

            </Alert>
        );
    }
}

export default HaproxyDescription;
